webpackJsonp([2],{

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/lib/api.js
// export const CORE_API_ENDPOINT = 'https://tbqapi.rmbainisys.com/api'
// export const CORE_API_ENDPOINT = 'https://rmtb.bainisyspro.com/api'
// export const CORE_API_ENDPOINT = 'http://localhost:1993'
var CORE_API_ENDPOINT = '/api';
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(292);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
var defaultDateFormat = 'MMMM DD, YYYY';
var defaultDateTimeFormat = 'MMMM DD, YYYY HH:mm';
// CONCATENATED MODULE: ./src/lib/auth.js




var RESULT = 'result';
var TOKEN = 'token';
var EXPIRES_ON = 'expires_on';
var SET_TIMEZONE = 'timaZome';

function getCookie(key) {
    return js_cookie_default.a.get(key);
}

function setCookie(key, value) {
    js_cookie_default.a.set(key, value);
}

function removeCookie(key) {
    js_cookie_default.a.remove(key);
}

function getToken() {
    return getCookie(TOKEN);
}

function getExpire() {
    return getCookie(EXPIRES_ON);
}

function getTimeZone() {
    var timezone = timeZone;
    if (getCookie(SET_TIMEZONE)) {
        timezone = getCookie(SET_TIMEZONE);
    }
    return timezone;
}

function setToken(obj) {
    var result = obj.result,
        token = obj.token,
        expires_on = obj.expires_on;

    setCookie(RESULT, result);
    setCookie(TOKEN, token ? token : "");
    setCookie(EXPIRES_ON, expires_on ? expires_on : "");
}

function clearToken() {
    removeCookie(RESULT);
    removeCookie(TOKEN);
    removeCookie(EXPIRES_ON);
}
// EXTERNAL MODULE: ./src/lib/withAuthCheck.js
var withAuthCheck = __webpack_require__(293);
var withAuthCheck_default = /*#__PURE__*/__webpack_require__.n(withAuthCheck);

// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CORE_API_ENDPOINT; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return getToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return getExpire; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return getTimeZone; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return setToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return clearToken; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateTimeFormat; });
/* unused concated harmony import withAuthCheck */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });





/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 422, 500, 502, 503];

function getAction(type, action, state, res) {
	return new Promise(function (resolve, reject) {
		if (!res) return resolve({ type: type });

		if (resStatusError.includes(res.status)) {
			if (res.status === 422) {
				return res.json().then(function (json) {
					var message = "";
					for (var key in json) {
						if (json.hasOwnProperty(key)) {
							var element = json[key];
							for (var k in element) {
								if (element.hasOwnProperty(k)) {
									var ele = element[k];
									message += "" + ele.msg;
									if (ele.param) message += " Param : " + ele.param + " ";
									message += "\n";
								}
							}
						}
					}

					return reject({
						statusText: res.statusText, data: {
							code: res.status.toString(),
							message: message
						}
					});
				});
			} else if (res.status === 404) {
				return reject({
					statusText: 404, data: {
						code: "404",
						message: "404 (Not Found)"
					}
				});
			} else {
				return res.json().then(function (data) {
					return reject({ statusText: res.statusText, data: data });
				});
			}
		}

		if ((typeof type === "undefined" ? "undefined" : _typeof(type)) === 'object') {
			if (type.payload) {
				var payload = type.payload(action, state, res);
				if (typeof payload.then === 'function') {
					//promise
					return payload.then(function (data) {
						return resolve({ type: type.type, payload: data });
					});
				} else {
					return resolve({ type: type.type, payload: payload });
				}
			}

			return resolve({ type: type.type });
		}

		res.json().then(function (payload) {
			return resolve({ type: type, payload: payload });
		});
	});
}

/* harmony default export */ var api = (function (_ref) {
	var getState = _ref.getState;
	return function (next) {
		return function (action) {
			if (_typeof(action[CALL_API]) !== 'object') return next(action);

			var _action$CALL_API = action[CALL_API],
			    endpoint = _action$CALL_API.endpoint,
			    _action$CALL_API$meth = _action$CALL_API.method,
			    method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
			    headers = _action$CALL_API.headers,
			    body = _action$CALL_API.body,
			    types = _action$CALL_API.types;

			var _types = _slicedToArray(types, 3),
			    request = _types[0],
			    success = _types[1],
			    failure = _types[2];

			var callBack = success.callBack;

			var state = getState();

			getAction(request, action, state).then(function (action) {
				return next(action);
			});

			if (callBack) {
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					callBack(action);
					next(action);
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true });
				});
			} else {
				fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
					return getAction(success, action, state, res);
				}).then(function (action) {
					return next(action);
				}).catch(function (err) {
					return next({ type: failure, payload: err, error: true });
				});
			}
		};
	};
});
// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


// import moment from 'moment-timezone'
// import {
//     getBSRSToken,
//     CORE_API_ENDPOINT,
//     setRefreshToken,
//     getTokenExpire,
//     getTimeZone
// } from 'Lib'

/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            next(action);
            // const expire = getTokenExpire()

            // const currentTime = moment().tz(getTimeZone())
            // const duration = moment.duration(moment.unix(expire).diff(currentTime))
            // const minutes = duration.asMinutes()

            // if (minutes < 5) {
            //     fetch(`${CORE_API_ENDPOINT}/user/newtoken`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'Authorization': `Bearer ${getBSRSToken()}`
            //         },
            //     })
            //         .then(res => res.json())
            //         .then(json => setRefreshToken(json))
            //         .then(() => next(action))
            // } else {
            //     next(action)
            // }
        };
    };
});
// EXTERNAL MODULE: ./src/lib/index.js + 3 modules
var lib = __webpack_require__(263);

// CONCATENATED MODULE: ./src/middlewares/setToken.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ var setToken = (function (store) {
  return function (next) {
    return function (action) {
      var entry = action[CALL_API];

      if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

      var token = void 0;
      var entryType = entry.types[0];

      if (entryType.startsWith("CORE") || entry.types[0].startsWith("O365") || entry.types[0].startsWith("SERVICE")) {
        token = Object(lib["d" /* getToken */])();
      }
      // else if (entry.types[0].startsWith("SERVICE")) {
      //   token = getO365Token()
      // }

      if (!token) return next(action);

      entry.headers = _extends({}, entry.headers, { 'Authorization': 'Bearer ' + token });

      next(action);
    };
  };
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(269);


/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root__);





var render = function render(Component) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__["AppContainer"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

render(__WEBPACK_IMPORTED_MODULE_3__features_ui_components_Root___default.a);

if (false) {
    module.hot.accept('./features/ui/components/Root', function () {
        return render(RootContainer);
    });
}

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(277);
} else {
    module.exports = require('./Root.dev');
}

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 6 modules
var react_router_dom = __webpack_require__(127);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 16 modules
var es = __webpack_require__(24);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(288);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new normalizr_es["a" /* schema */].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(289);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(175);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 242 modules
var dist_es = __webpack_require__(128);

// CONCATENATED MODULE: ./src/features/ui/selectors.js
function getIsLoading(state) {
    return state.ui.isLoading;
}

function getHasError(state) {
    return state.ui.hasError;
}

function getHasBSRSLoginFail(state) {
    return state.ui.hasBSRSLoginFail === true;
}

function getErrorMessage(state) {
    return state.ui.errorMessage;
}

function getErrorCode(state) {
    return state.ui.errorCode;
}

function getUiMessage(state) {
    return state.ui;
}

function getError(state) {
    return state.ui.error;
}
// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(83);

// CONCATENATED MODULE: ./src/error.js

// 0000 => api error
// 0001 => backend error
// 0002 => fronted error

var errorMessage = {
	// default error
	"00010000": "Something went wrong. Please try again later.",

	// custom error
	"00010001": "asfsdfdsfdsf sdfdsf dsf"
};

/* harmony default export */ var src_error = ({
	errorMessage: errorMessage
});
// CONCATENATED MODULE: ./src/features/ui/actions.js





function setError(hasError) {
	var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var defaultError = {
		code: "00010000",
		message: src_error.errorMessage["00010000"]
	};

	if (typeof error === 'string' && error in src_error.errorMessage) {
		defaultError = {
			code: error,
			message: src_error.errorMessage[error]
		};
	} else if (error !== null && error.code !== undefined && error.message !== undefined) {
		defaultError = error;
	} else if (error === null || hasError === false) {
		defaultError = null;
	}

	return {
		type: types["g" /* SET_ERROR */],
		hasError: hasError,
		error: defaultError
	};
}
// CONCATENATED MODULE: ./src/features/ui/components/ErrorMessageDialog.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








__webpack_require__(568);

var ErrorMessageDialog_ErrorMessage = function (_React$Component) {
	_inherits(ErrorMessage, _React$Component);

	function ErrorMessage() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, ErrorMessage);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErrorMessage.__proto__ || Object.getPrototypeOf(ErrorMessage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { open: _this.props.hasError }, _this.close = function () {
			_this.setState({ open: false });
			_this.props.clearError();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(ErrorMessage, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProp) {
			this.setState({ open: nextProp.hasError });
		}
	}, {
		key: 'render',
		value: function render() {
			return react_default.a.createElement(
				dist_es["e" /* Modal */],
				{ open: this.state.open, onClose: this.close, size: 'small' },
				react_default.a.createElement(
					dist_es["e" /* Modal */].Content,
					{ style: { height: 'auto' } },
					react_default.a.createElement(
						'div',
						{ className: 'errormessage' },
						react_default.a.createElement(
							'div',
							{ className: 'contenterror' },
							react_default.a.createElement(
								'div',
								{ className: 'content-image' },
								react_default.a.createElement(dist_es["d" /* Image */], { src: '/assets/images/icon-warning-red.png' })
							),
							react_default.a.createElement(
								'div',
								{ className: 'content-text' },
								react_default.a.createElement('p', null),
								this.props.hasError && this.props.error != null && this.props.error.code !== undefined && this.props.error.message !== undefined ? react_default.a.createElement(
									'p',
									null,
									this.props.error.message
								) : react_default.a.createElement(
									'p',
									null,
									'Something went wrong.'
								)
							)
						),
						react_default.a.createElement(
							'div',
							{ className: 'close', onClick: this.close },
							react_default.a.createElement(dist_es["d" /* Image */], { src: '/assets/images/icon-cross-red.png' })
						)
					)
				)
			);
		}
	}]);

	return ErrorMessage;
}(react_default.a.Component);

/* harmony default export */ var ErrorMessageDialog = (Object(Recompose["a" /* compose */])(Object(es["connect"])(function (state, props) {
	return {
		hasError: getHasError(state),
		error: getError(state)
	};
}, function (dispatch) {
	return {
		clearError: function clearError() {
			dispatch(setError(false));
		}
	};
}))(ErrorMessageDialog_ErrorMessage));
// CONCATENATED MODULE: ./src/features/ui/components/Loading.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var Loading_LoadingComponent = function LoadingComponent(props) {
	return props.isLoading ? react_default.a.createElement(
		dist_es["c" /* Dimmer */],
		{ active: true },
		react_default.a.createElement(dist_es["d" /* Image */], { src: '/assets/images/47tj.gif', style: { display: "inline", width: '100px' } })
	) : "";
};

/* harmony default export */ var components_Loading = (Object(Recompose["a" /* compose */])(Object(es["connect"])(function (state) {
	return {
		isLoading: getIsLoading(state)
	};
}), Object(Recompose["c" /* withProps */])(function (props) {
	return _extends({}, props);
}))(Loading_LoadingComponent));
// EXTERNAL MODULE: ./node_modules/react-loadable/lib/index.js
var lib = __webpack_require__(571);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/features/ui/components/Loadable.js
var Loadable__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Loadable_Loading = function Loading() {
    return react_default.a.createElement(
        dist_es["c" /* Dimmer */],
        { active: true },
        react_default.a.createElement(dist_es["d" /* Image */], { src: '/assets/images/47tj.gif', style: { display: "inline", width: '100px' } })
    );
};

/* harmony default export */ var Loadable = (function (opts) {
    return lib_default()(Loadable__extends({
        loading: Loadable_Loading
    }, opts));
});
// CONCATENATED MODULE: ./src/lib/routePermission.js
var routePermission__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



// import { getBSRSToken, getIsIntegration } from './'

// const Auth = {
// 	isAuthenticated: () => {
// 		const bsrsToken = getBSRSToken()

// 		return !!bsrsToken
// 	},
// 	isIntegration: () => {
// 		const isIntegration = getIsIntegration()
// 		return !!isIntegration
// 	}
// }

var routePermission_PrivateRoute = function PrivateRoute(_ref) {
	var Component = _ref.component,
	    rest = _objectWithoutProperties(_ref, ['component']);

	return react_default.a.createElement(react_router_dom["d" /* Route */], routePermission__extends({}, rest, { render: function render(props) {
			// if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
			// 	return <Redirect to='/login' />
			// }

			// if (Auth.isIntegration() === false && props.match.url !== "/integration") {
			// 	return <Redirect to='/integration' />
			// }

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return react_default.a.createElement(react_router_dom["c" /* Redirect */], { to: '/' });
			}
		} }));
};

var routePermission_PublicRoute = function PublicRoute(_ref2) {
	var Component = _ref2.component,
	    rest = _objectWithoutProperties(_ref2, ['component']);

	return react_default.a.createElement(react_router_dom["d" /* Route */], routePermission__extends({}, rest, { render: function render(props) {

			// if (Auth.isAuthenticated() === true && props.match.url === "/login") {
			// 	return <Redirect to='/' />
			// }

			if (Component !== undefined) {
				return react_default.a.createElement(Component, props);
			} else {
				return "";
			}
		} }));
};


// CONCATENATED MODULE: ./src/features/ui/components/Routes.js





// const AsyncHome = Loadable({
//     loader: () => import('./Home')
// })

var AsyncNotFound = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 844));
    }
});

var AsyncHomeDisplay = Loadable({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 845));
    }
});

/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        react_router_dom["e" /* Switch */],
        null,
        react_default.a.createElement(routePermission_PublicRoute, { exact: true, path: '/', component: AsyncHomeDisplay }),
        react_default.a.createElement(routePermission_PrivateRoute, { component: AsyncNotFound })
    );
});
// CONCATENATED MODULE: ./src/features/ui/components/App.js

// import Header from './Header'
// import Breadcrumb from './Breadcrumb'

// import Footer from './Footer'
// import { Container } from 'semantic-ui-react'

/* harmony default export */ var App = (function () {
    return react_default.a.createElement(
        'div',
        null,
        react_default.a.createElement(Routes, null)
    );
});
// CONCATENATED MODULE: ./src/features/ui/components/Root.prod.js








var store = configureStore_default()();

/* harmony default export */ var Root_prod = __webpack_exports__["default"] = (function () {
	return react_default.a.createElement(
		es["Provider"],
		{ store: store },
		react_default.a.createElement(
			'div',
			null,
			react_default.a.createElement(
				react_router_dom["a" /* BrowserRouter */],
				null,
				react_default.a.createElement(App, null)
			),
			react_default.a.createElement(ErrorMessageDialog, null),
			react_default.a.createElement(components_Loading, null)
		)
	);
});

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(290);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(66);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(291);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(264);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 228 modules
var redux_form_es = __webpack_require__(294);

// EXTERNAL MODULE: ./node_modules/reapop/lib/index.js
var lib = __webpack_require__(300);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/types.js
var types = __webpack_require__(83);

// CONCATENATED MODULE: ./src/features/ui/reducer.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var reducer_initialState = {
	hasError: false,
	isLoading: false,
	error: null
};
/* harmony default export */ var reducer = (function () {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducer_initialState;
	var action = arguments[1];


	switch (action.type) {
		case types["e" /* EX_REQUEST */]:
			return _extends({}, state, {
				isLoading: true,
				hasError: false,
				error: null
			});
		case types["f" /* EX_SUCCESS */]:
			return _extends({}, state, {
				isLoading: false,
				hasError: false,
				error: null
			});
		case types["d" /* EX_FAILURE */]:
			var returnData = _extends({}, state, {
				isLoading: false,
				hasError: true,
				error: action.payload.data
			});
			return returnData;
		case types["g" /* SET_ERROR */]:
			return _extends({}, state, {
				hasError: action.hasError,
				error: action.error
			});
		default:
			return state;
	}
});
// CONCATENATED MODULE: ./src/reducers/reducerRoom.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


var initialStateObj = {};
// requestState = 'request'
// , initialState = []
// , initialStateObj = {}
/* harmony default export */ var reducerRoom = ({
   room: function room() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateObj;
      var action = arguments[1];

      switch (action.type) {
         case types["b" /* CORE_LOAD_ROOMINFO_REQUEST */]:
            return state;
         case types["c" /* CORE_LOAD_ROOMINFO_SUCCESS */]:
            var result = {};
            if (action && action.payload && _typeof(action.payload) === 'object') {
               result = action.payload;
            }
            return result;
         default:
            return state;
      }
   }
});
// CONCATENATED MODULE: ./src/reducers/reducerAuth.js
var reducerAuth__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


var reducerAuth_initialStateObj = {};
// requestState = 'request'
// , initialState = []
// , initialStateObj = {}
/* harmony default export */ var reducerAuth = ({
   auth: function auth() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerAuth_initialStateObj;
      var action = arguments[1];

      switch (action.type) {
         case types["i" /* VERIFY_REQUEST */]:
            return state;
         case types["j" /* VERIFY_SUCCESS */]:
            var result = {};
            if (action && action.payload && reducerAuth__typeof(action.payload) === 'object') {
               result = action.payload;
            }
            return result;
         default:
            return state;
      }
   }
});
// CONCATENATED MODULE: ./src/reducers.js







/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["a" /* reducer */],
    notifications: Object(lib["reducer"])(),
    ui: reducer,
    room: reducerRoom.room,
    auth: reducerAuth.auth
}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], redux_thunk_es["a" /* default */]];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

// import React from 'react'
// import { connect } from 'react-redux' 
// import { Redirect } from 'react-router-dom'
// import {
//   setDisplayName,
//   branch,
//   renderComponent,
//   compose
// } from 'recompose'
// import { getIsLoggedIn } from 'Features/auth/selectors'

// const RedirectToLogin = () => <Redirect to='/login' />
// const withAuthCheck = WrappedComponent => props => (
//   <WrappedComponent {...props} />
// )

// export default WrappedComponent => compose(
//   setDisplayName('withAuthCheck'),
//   connect(
//     state => ({
//         isLoggedIn: getIsLoggedIn(state)
//     })
//   ),
//   branch(
//     ({ isLoggedIn }) => isLoggedIn,
//     withAuthCheck,
//     renderComponent(RedirectToLogin)
//   )
// )(WrappedComponent)

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(569);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(267)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./modalErrorMessageDialog.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./modalErrorMessageDialog.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(266)(false);
// imports


// module
exports.push([module.i, "html body{height:100vh;overflow:hidden;position:relative;top:0;left:0}.ui.modal .content{padding:5px}.errormessage{position:relative}.errormessage .contenterror{padding:3rem}.errormessage .contenterror .content-image{text-align:center}.errormessage .contenterror .content-image img{display:inline-block}.errormessage .contenterror .content-text{text-align:center}.errormessage .contenterror .content-text p{font-size:26px}.errormessage .close{position:absolute;cursor:pointer;top:0;right:0;padding:5px}.errormessage .close img{display:inline-block;width:25px;height:25px}", ""]);

// exports


/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EX_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EX_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EX_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return VERIFY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return VERIFY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return VERIFY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_LOAD_ROOMINFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CORE_LOAD_ROOMINFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_LOAD_ROOMINFO_FAILURE; });
// export const LOGOUT = 'LOGOUT'
var SET_ERROR = 'SET_ERROR';

var EX_REQUEST = 'EX_REQUEST';
var EX_SUCCESS = 'EX_SUCCESS';
var EX_FAILURE = 'EX_FAILURE';

var VERIFY_REQUEST = 'VERIFY_REQUEST';
var VERIFY_SUCCESS = 'VERIFY_SUCCESS';
var VERIFY_FAILURE = 'VERIFY_FAILURE';

var CORE_LOAD_ROOMINFO_REQUEST = 'CORE_LOAD_ROOMINFO_REQUEST';
var CORE_LOAD_ROOMINFO_SUCCESS = 'CORE_LOAD_ROOMINFO_SUCCESS';
var CORE_LOAD_ROOMINFO_FAILURE = 'CORE_LOAD_ROOMINFO_FAILURE';

/***/ })

},[268]);


// WEBPACK FOOTER //
// app.59ae80a189662df9713f.js